module.exports = __webpack_public_path__ + "static/media/myimg.4bbff778.jpeg";